<template>
    <div class="flex flex-col md:flex-row items-start md:items-center justify-between border-t border-gray-400 py-2 sm:py-3 lg:py-4">
        <div class="flex flex-1 items-center leading-snug group pr-6">
            <div class="flex-none block self-start w-6 mr-1 mt-0.5">
                <i class="far fa-file text-blue-500"></i>
            </div>

            <span class="font-semibold text-base lg:text-md mr-4">
                <span class="mr-3">{{ document.display_filename }}</span><span class="font-normal inline-block text-gray-600 text-xs sm:text-sm mt-1">{{ document.size_for_humans }}</span>
            </span>
        </div>

        <div class="w-full md:w-auto flex justify-end">
            <div class="flex flex-none items-center h-12 space-x-4">
                <a class="flex-none text-sm text-blue-500 hover:text-blue-700 cursor-pointer py-1 px-3 rounded border border-blue-500 hover:border-blue-700 hover:bg-blue-100"
                    :href="document.download_route"
                >
                    <i class="far fa-arrow-alt-circle-down mr-1"></i>
                    Download
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        document: {},
    },
}
</script>
